import { useEffect, useCallback, useRef } from 'react'
import debounce from 'lodash/debounce';

const useDebounce = (callback, delay) => {
  // set the default delay if not passed in by the caller
  if (!delay) delay = 500

  // eslint complains about wanting to use a inline function for callback
  // which is not going to happen in this case,
  // eslint-disable-next-line
  const memoizedCallback = useCallback(callback, [])
  const debouncedFn = useRef(debounce(memoizedCallback, delay))

  useEffect(() => {
    debouncedFn.current = debounce(memoizedCallback, delay)
  }, [memoizedCallback, debouncedFn, delay])

  return debouncedFn.current
}

export default useDebounce
